<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light px-0 p-0">
    <button class="navbar-toggler ml-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse px-4 p-lg-0" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto">
        <li v-for="menu in menus" v-bind:key="menu.MenuId" v-bind:class="(menu.Submenus.length > 0 ? CLASE_DROPDOWN : CLASE_ACTIVE)" class="nav-item" role="button" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" @mouseleave="menu.Mostrar = false">
        
          <a v-if="menu.EsDescarga == true && menu.AbrirEnVisor == false" :href="menu.RutaParaAccesar" class="nav-link">{{menu.Titulo}}</a>
          <a v-else-if="menu.EsDescarga == true && menu.AbrirEnVisor == true" v-on:click="AbreElVisor(menu.RutaParaAccesar);"  class="nav-link">{{menu.Titulo}}</a>
          <a v-else-if="menu.EsDescarga == true && menu.AbrirEnVisor == false" :href="menu.RutaParaAccesar" class="nav-link">{{menu.Titulo}}</a>
          <a v-else-if="menu.RutaParaAccesar != null && menu.RutaParaAccesar.includes('http') && menu.AbrirEnVisor == false" class="nav-link" target="_blank" :href="menu.RutaParaAccesar">{{menu.Titulo}}</a>
          <router-link v-else-if="menu.RutaParaAccesar != null && menu.AbrirEnVisor == false" class="nav-link" :to="menu.RutaParaAccesar">{{menu.Titulo}}</router-link>
          <a v-else class="nav-link dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="menu.Mostrar = !menu.Mostrar;" v-bind:class="{ show: menu.Mostrar }">{{menu.Titulo}}</a>
          <div v-if="menu.Submenus.length > 0 && menu.Mostrar == true" class="dropdown-menu acercarAlMenu" aria-labelledby="navbarDropdown" @mouseleave="menu.Mostrar = false" v-bind:class="{ show: menu.Mostrar }" >
            <ul>
              <SubmenusQueMePertenecen v-for="submenu in menu.Submenus" v-bind:key="submenu.SubmenuId" :submenu="submenu"></SubmenusQueMePertenecen>
            </ul>
          </div>
         
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>  
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";
import SubmenusQueMePertenecen from "@/components/PaginaOficial/Comun/MenuResponsivo/Submenus.vue";


  export default {
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        CLASE_DROPDOWN: "dropdown",
        CLASE_ACTIVE: "active",
        PAGINA_DE_INICIO: 1,
        TIPO_POSICION: 1,
        ES_MENU_ESPECIAL: false,
        RUTA_LOCAL:'\\\\themisfs',
        menus: [],
        nombreDeVariableDelComponente: "cargoMenuResponsivo"
      }
    },
    components: {
      SubmenusQueMePertenecen
    },
    methods: {
      AbreElVisor: function(vinculo) {
        this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.RUTA_LOCAL));
      },
      CargaElMenu: function() {
        let parametros = {
          EsPrueba: this.enumeraciones.EsPrueba, 
          PaginaDeInicioId: this.PAGINA_DE_INICIO, 
          TipoPosicionId: this.TIPO_POSICION, 
          EsMenuEspecial: this.ES_MENU_ESPECIAL
        }

        axios
          .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta.data);
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            } else {
              this.menus = respuesta.data.Menus;
             // console.log("MENUS:::",this.menus)
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
            }
          })
          .catch(excepcion => {
            console.error(excepcion);
            this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
          });
      }, 
      AbrirDocumento: function(vinculo, formaDeApertura) {
        window.open(vinculo, formaDeApertura);
      },

      YaTermineDeCargar: function(estatus) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
      }
    },
    mounted() {
      this.CargaElMenu();
    }
  }
</script>

<style scoped>
  #navbarSupportedContent {
    background-color:#ffffff
  }

  a {
    font-size: 1rem;
  }

  .acercarAlMenu {
    margin-top: 0px;
  }

  .navbar {
    height: 62px;
    z-index: 10 !important;
  }

  .nav-link {
    cursor: pointer;
  }

  .bg-light {
    background-color: #ffffff !important;
  }

  .dropdown-menu {
    background-color: rgb(34,34,34);
    color: #FFF;
    padding: 0;
  }

    .dropdown-menu ul {
      list-style: none;
      padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuResponsivo/MenuResponsivo.vue